import React from 'react';
export default function Filter() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21" height="14" viewBox="0 0 21 14">
		  <g id="Group_284" data-name="Group 284" transform="translate(-225 -728)">
		    <line id="Line_32" data-name="Line 32" x1="21" transform="translate(225 741)" fill="none" stroke="#034b45" strokeWidth="2"/>
		    <line id="Line_33" data-name="Line 33" x1="21" transform="translate(225 735)" fill="none" stroke="#034b45" strokeWidth="2"/>
		    <line id="Line_34" data-name="Line 34" x1="21" transform="translate(225 729)" fill="none" stroke="#034b45" strokeWidth="2"/>
		  </g>
		</svg>
	);
}
